import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import FedsearchNav from '../FedsearchNav';
import IntroductionSection from '../sections/IntroductionSection';
import TestUrlSection from '../sections/TestUrlSection';
import LiveUrlSection from '../sections/LiveUrlSection';
import AuthenticationSection from '../sections/AuthenticationSection';
import EndpointSection from '../sections/EndpointSection';
import SearchResultSection from '../sections/SearchResultSection';
import CandidateDetailsSection from '../sections/CandidateDetailsSection';
import CvDownloadSection from '../sections/CvDownloadSection';
import CvPreviewSection from '../sections/CvPreviewSection';
import CreditUsageSection from '../sections/CreditUsageSection';
import DictionarySection from '../sections/DictionarySection';
import ApplicationSection from '../sections/ApplicationSection';
import ApplicationSummarySection from '../sections/ApplicationSummarySection';
import ErrorCodeSection from '../sections/ErrorCodeSection';
import ImplementationSection from '../sections/ImplementationSection';
import './styles.css';

type Section = { id: string; top: number };

const FederatedSearchApi = () => {
  const [sectionInView, setSectionInView] = useState<Section>({ id: 'introduction', top: 0 });
  const sections: Section[] = [];

  useEffect(() => {

    let elements = document.querySelectorAll('section');
    elements.forEach(el => {
      sections.push({ id: el.id, top: el.getBoundingClientRect().top })
    });

    window.scrollTo(0,0);
    setSectionInView(sections[0]);

    window.addEventListener('scroll', updateSectionInView);
  }, []);
  
  function updateSectionInView() {
    const initialScrollY: number = sections[0].top;

    sections.forEach((section, i) => {
        if (sections[i + 1]) {
          if (window.scrollY > sections[sections.length - 1].top - initialScrollY - 3) {
            setSectionInView(sections[sections.length - 1]);
            return;
          }
            if (window.scrollY > section.top - initialScrollY - 3 && window.scrollY < sections[i + 1].top - initialScrollY - 3) {
              setSectionInView(section);
          }
        }
    });
  }

  return (
    <div>
      <Row>
        <Col md="3">
          <div className="sticky-top fed-nav" style={{ paddingTop: 20 }}>
            <FedsearchNav selected={sectionInView?.id} />
          </div>
        </Col>
        <Col md="9">
          <Container fluid={true} className="document-content">
            <IntroductionSection />
            <TestUrlSection />
            <LiveUrlSection />
            <AuthenticationSection />
            <EndpointSection />
            <SearchResultSection />
            <CandidateDetailsSection />
            <CvDownloadSection />
            <CvPreviewSection />
            <CreditUsageSection />
            <DictionarySection />
            <ApplicationSection />
            <ApplicationSummarySection />
            <ErrorCodeSection />
            <ImplementationSection />
          </Container>
        </Col>
      </Row>
    </div>
  );
};

export default FederatedSearchApi;
